<template>
    <b-modal
        ref="errorModal"
        title="Error"
        ok-only
        header-bg-variant="danger"
        header-text-variant="light"
        @ok="action"
        ok-variant="secondary"
    >
        <p>{{ message }}</p>
    </b-modal>
</template>

<script>
export default {

    name: 'ErrorModal',
    props: ["action"],

    data: function() {
        return {
            error: {}
        };
    },

    computed: {
        message: function() {
            if (this.error.response) {
                if (this.error.response.status === 404) {
                    return "Sorry this does not exist";
                } else if (this.error.response.statusText) {
                    return this.error.response.statusText;
                } else {
                    return "Server error";
                }
            } else {
                return "There was an unknown error";
            }
        }
    },

    methods: {
        show: function(error) {
            this.error = error;
            this.$refs.errorModal.show();
        }
    }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/modals/ErrorComponent.vue